(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    const loadRecommendations = async () => {
      if (section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';
      try {
        const response = await fetch(section.dataset.url);
        if (!response.ok) return;
        const wrapper = document.createElement('div');
        wrapper.innerHTML = await response.text();
        const content = wrapper.querySelector('[data-product-recommendations]');
        if (content?.innerHTML.trim()) section.innerHTML = content.innerHTML;
      } catch (error) {}
    };
    if (!('IntersectionObserver' in window)) {
      loadRecommendations();
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      loadRecommendations();
    }, { rootMargin: '0px 0px 300px' });
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shift-checkin"] && !Shopify.designMode) return;
  try {
    
  function initializeShiftCheckins(scope) {
    scope.querySelectorAll('[data-shift-checkin]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const choices = section.querySelectorAll('[data-shift-choice]');
      const results = section.querySelectorAll('[data-shift-result]');

      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          choices.forEach((item) => {
            const active = item === choice;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          results.forEach((result) => {
            result.hidden = result.id !== choice.dataset.target;
          });
        });
      });
    });
  }

  initializeShiftCheckins(document);
  document.addEventListener('shopify:section:load', (event) => initializeShiftCheckins(event.target));

  } catch(e) { console.error(e); }
})();
})();
